import React, { useState, useRef, useEffect, useCallback } from "react";
import TerritoryWise from "./TerritoryWise";
import PlanActuals from "./PlanActuals";
import Trainers from "./Trainers";
import FeedbackAnalysis from "./FeedbackAnalysis";
import YearlyAnalysis from "./YearAnalysis";
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { styled, useTheme } from "@mui/material/styles";

const CustomToggleButton = styled(ToggleButton)(({ theme }) => ({
    "&.MuiToggleButton-root": {
        lineHeight: 0.75,
        borderRadius: '8px',
        backgroundColor: '#32383E'
    },
    "&.MuiToggleButton-root.Mui-selected": {
        color: 'white',
        background: 'linear-gradient(#57380B, #A06C21)'
    }
}))

const TrainingDashboard = () => {
    const [switchValues, setSwitchValues] = useState("territoryWise");

    const handleToggleChange = (event, newValue) => {
        setSwitchValues(newValue);
    }

    return (
        <>
            <div className="px-28 pb-16">
                <ToggleButtonGroup
                    color="primary"
                    value={switchValues}
                    exclusive
                    onChange={handleToggleChange}
                    aria-label="Request"
                >
                    <CustomToggleButton value="territoryWise">TERRITORY-WISE</CustomToggleButton>
                    <CustomToggleButton value="planActual">PLAN VS ACTUALS</CustomToggleButton>
                    <CustomToggleButton value="trainers">TRAINERS</CustomToggleButton>
                    <CustomToggleButton value="feedbackAnalysis">FEEDBACK ANALYSIS</CustomToggleButton>
                    <CustomToggleButton value="yearlyAnalysis">YEARLY ANALYSIS</CustomToggleButton>
                </ToggleButtonGroup>
            </div>
            <div className={switchValues === "territoryWise" ? 'h-full' : 'hidden'}>
                <TerritoryWise />
            </div>
            <div className={switchValues === "planActual" ? 'h-full' : 'hidden'}>
                <PlanActuals />
            </div>
            <div className={switchValues === "trainers" ? 'h-full' : 'hidden'}>
                <Trainers />
            </div>
            <div className={switchValues === "feedbackAnalysis" ? 'h-full' : 'hidden'}>
                <FeedbackAnalysis />
            </div>
            <div className={switchValues === "yearlyAnalysis" ? 'h-full' : 'hidden'}>
                <YearlyAnalysis />
            </div>
        </>
    )
}
export default TrainingDashboard;